import { useEffect, useRef, useState } from 'react';

/**
 * 엘리먼트가 뷰포트에 진입했는지 감지
 * 웹뷰(iOS WKWebView 12.1+, Android WebView 51+) 호환
 *
 * @param {object} opts
 * @param {number} opts.threshold 0~1 (default 0.3)
 * @param {boolean} opts.once     한 번만 트리거 후 disconnect (default true)
 * @returns {[ref, boolean]}
 */
export const useInView = ({ threshold = 0.3, once = true } = {}) => {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        // IntersectionObserver 미지원 환경 fallback (즉시 트리거)
        if (typeof IntersectionObserver === 'undefined') {
            setInView(true);
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    if (once) observer.disconnect();
                } else if (!once) {
                    setInView(false);
                }
            },
            { threshold }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [threshold, once]);

    return [ref, inView];
};